const actions={
  SetOpenid(context) {  //自定义触发mutations里函数的方法，context与store 实例具有相同方法和属性
    context.commit('SetOpenid');
  },

  Setjssdk(context,data) {   //同上注释，num为要变化的形参
    context.commit('SetJSSDK',data)
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/actions.js